module.exports = __webpack_public_path__ + "img/product-ketang-jbxl-04.27f0fdd2.png";